export default __webpack_public_path__ + "static/media/g2.6b52692a.png";